import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './VerificationFailedModal.css';
import cs from '../../components/commonStyle.css';
import { Modal, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import messages from '../../locale/messages';
import error_icon from '../../../public/siteImages/errorIconRed.svg';

class VerificationFailedModal extends Component {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        show: PropTypes.bool.isRequired,
    };

    render() {
        const { onClose, show } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Modal show={show} animation={false} onHide={onClose} className="verificationModal">
                <div className={cx(s.sectionBlock)}>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                        <div className={cx(s.verificationContent, cs.textAlignCenter)}>
                            <img src={error_icon} alt="Verification Failed" />
                            <h2 className={cx(s.titleText)}>{formatMessage(messages.verificationFailedTitle)}</h2>
                            <p className={cx(s.contentText)}>{formatMessage(messages.verificationFailedDescription)}</p>
                            <Button className={cx(cs.btnPrimary, cs.fullWidth, cs.commonMediumText)} onClick={onClose}>
                                {formatMessage(messages.verificationFailedTryAgain)}
                            </Button>
                        </div>
                    </Modal.Body>
                </div>
            </Modal>
        );
    }
}

const mapState = state => ({});

const mapDispatch = {};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(VerificationFailedModal))); 